import Logger from '../../../lib/analytics/logger';
import { LTO_EVENT_TYPES } from '../constants/events';
import { EVENT_ACTIONS, EVENT_DOMAINS, EVENT_SCREENS, EVENT_WIDGETS } from '../../../lib/analytics/constants';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
export var sendLTOEvent = function sendLTOEvent(eventType) {
  switch (eventType) {
    case LTO_EVENT_TYPES.DISMISS_LTO_CONFIRMATION_SCREEN:
      Logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.PRESS,
        domain: EVENT_DOMAINS.LIMITED_TIME_OFFER,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].LOBBY,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.GENERAL].DISMISS_BUTTON
      });
      break;
    case LTO_EVENT_TYPES.ACCEPT_LTO_CONFIRMATION_SCREEN:
      Logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.PRESS,
        domain: EVENT_DOMAINS.LIMITED_TIME_OFFER,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].LOBBY,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.GENERAL].ACCEPT_BUTTON
      });
      break;
    default:
      break;
  }
};